var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 0.5C7.62492 0.5 7.24992 0.6425 6.94242 0.9425L0.942422 6.9425C0.349922 7.5275 0.349922 8.4725 0.942422 9.0575L6.94242 15.0575C7.52742 15.65 8.47242 15.65 9.05742 15.0575L15.0574 9.0575C15.6499 8.4725 15.6499 7.5275 15.0574 6.9425L9.05742 0.9425C8.74992 0.6425 8.37492 0.5 7.99992 0.5ZM7.99992 4.2125C10.0249 4.295 10.9024 6.335 9.70992 7.8575C9.39492 8.2325 8.89242 8.48 8.63742 8.8025C8.37492 9.125 8.37492 9.5 8.37492 9.875H7.24992C7.24992 9.2375 7.24992 8.705 7.51242 8.33C7.75992 7.955 8.26242 7.73 8.57742 7.4825C9.49992 6.635 9.25992 5.4425 7.99992 5.345C7.38492 5.345 6.87492 5.8475 6.87492 6.4775H5.74992C5.74992 5.225 6.76242 4.2125 7.99992 4.2125ZM7.24992 10.625H8.37492V11.75H7.24992V10.625Z",
    fill: "#CBCCE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.46ee95b50b4543193b92ba733b395361.svg";
export { ForwardRef as ReactComponent };